import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ASSETS, PROJECTS, FOOTER } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-slate-300 overflow-hidden">
      <div className="pointer-events-none absolute -top-24 left-1/4 h-72 w-72 rounded-full bg-brand/25 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-24 right-10 h-72 w-72 rounded-full bg-leaf/15 blur-[120px]" />

      <div className="container-x relative py-20 md:py-24">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <img src={ASSETS.logo} alt="Făt-Frumos" className="h-11 w-auto mb-8 brightness-0 invert" />
            <p className="max-w-md text-2xl md:text-3xl font-display font-semibold leading-tight text-white">
              Hai să scriem împreună următoarea poveste de brand.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="btn mt-7 px-7 py-3.5 bg-white text-ink hover:scale-[1.03]"
            >
              Contactează-ne
            </Link>

            <div className="mt-10 flex items-center gap-8">
              <img src={ASSETS.isicWhite} alt="ISIC" className="h-9 w-auto opacity-90" />
              <img src={ASSETS.eycaWhite} alt="Cardul European de Tineret" className="h-9 w-auto opacity-90" />
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-extrabold uppercase tracking-[0.18em] mb-5">
              {FOOTER.projectsTitle}
            </h4>
            <ul className="space-y-3">
              {PROJECTS.map((p) => (
                <li key={p.href}>
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noreferrer"
                    className="group inline-flex items-center gap-1.5 text-slate-300 hover:text-white transition-colors"
                  >
                    {p.label}
                    <ArrowUpRight className="h-4 w-4 text-slate-500 group-hover:text-brand transition-colors" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-extrabold uppercase tracking-[0.18em] mb-5">
              {FOOTER.quickTitle}
            </h4>
            <ul className="space-y-3">
              {FOOTER.quick.map((q) => (
                <li key={q.to}>
                  <Link to={q.to} className="text-slate-300 hover:text-white transition-colors">
                    {q.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8 text-sm text-slate-400">
          {FOOTER.copyright}
        </div>
      </div>
    </footer>
  );
}
